// Estimate calculator (corporate spec §4.2; wedding spec §4.2 reuses it). No backend: prices come from the JSON config the
// section renders from the same data as its pricing table. Formats are either "tiers" (price per person by group size)
// or "from" (a starting price per guest). Copy comes from the section settings ({total}, {count} tokens).
const track = (name, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.gtag === 'function') window.gtag('event', name, params);
  try { window.Shopify?.analytics?.publish?.(name, params); } catch (error) { /* analytics must never break the page */ }
};

if (!window.customElements.get('estimate-calculator')) {
  window.customElements.define('estimate-calculator', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-estimate-config]').textContent);
      this.money = new Intl.NumberFormat(this.config.locale || 'en-CA', { style: 'currency', currency: this.config.currency || 'CAD', maximumFractionDigits: 0 });
      this.count = this.querySelector('[data-estimate-count]');
      this.countOutput = this.querySelector('[data-estimate-count-output]');
      this.location = this.querySelector('[data-estimate-location]');
      this.result = this.querySelector('[data-estimate-result]');
      this.note = this.querySelector('[data-estimate-note]');
      this.cta = this.querySelector('[data-estimate-cta]');
      this.lastTracked = '';

      this.addEventListener('input', () => this.update(true));
      this.addEventListener('change', () => this.update(true));
      this.cta.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('inquiry:prefill', { bubbles: true, detail: { headcount: this.state.count, format: this.state.format } }));
      });
      this.update();
    }

    get format() {
      return this.querySelector('input[type="radio"]:checked')?.value || 'workshop';
    }

    fill(template, values) {
      return (template || '').replace(/\{(\w+)\}/g, (match, key) => (key in values ? values[key] : match));
    }

    estimate(format, count) {
      const rule = this.config.formats[format];
      if (!rule) return null;
      if (rule.mode === 'tiers') {
        const tier = rule.tiers.find((t) => count >= t.min && (t.max == null || count <= t.max)) || (count < rule.tiers[0]?.min ? rule.tiers[0] : null);
        return tier ? { total: tier.price * count, exact: true } : null;
      }
      return rule.price ? { total: rule.price * count, exact: false } : null;
    }

    // Only a visitor's own change is tracked, never the initial render.
    update(byVisitor = false) {
      const count = Number(this.count.value);
      const format = this.format;
      const rule = this.config.formats[format] || {};
      const location = this.location?.value || 'studio';
      const result = this.estimate(format, count);
      const strings = this.config.strings;
      this.state = { count, format, location };

      this.countOutput.value = count;
      this.countOutput.textContent = count;
      this.result.textContent = result ? this.fill(strings[format], { total: this.money.format(result.total), count }) : '';

      const notes = [];
      if (format === 'workshop' && rule.waves_over && count > rule.waves_over && strings.waves) notes.push(strings.waves);
      if (format === 'bar' && rule.min && count < rule.min && strings.bar_small) notes.push(strings.bar_small);
      // Prices are for a session at the studio: any other location, and every perfume bar (always at the client's
      // venue), adds on-site service, setup and travel, which the proposal quotes.
      if ((location !== 'studio' || format === 'bar') && strings.onsite) notes.push(strings.onsite);
      this.note.textContent = notes.join(' ');
      this.note.hidden = notes.length === 0;
      this.cta.textContent = this.fill(strings.cta, { count });

      if (!byVisitor) return;
      clearTimeout(this.trackTimer);
      this.trackTimer = setTimeout(() => {
        const key = `${format}|${count}|${location}`;
        if (key === this.lastTracked || !result) return;
        this.lastTracked = key;
        track(`${this.dataset.eventPrefix || 'estimate'}_estimate_calculated`, { headcount: count, format, location, estimate: result.total });
      }, 1500);
    }
  });
}
